function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function splitString(string, charFrom, charTo) {
    return string.split(charFrom).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(charTo);
}

function isNumericOrEmpty(string) {
    return string === '' || Number.isFinite(Number(string));
}

function getFirstLetters(str) {
    return str
    .toLowerCase()
    .match(/\b[a-z0-9]/g)
    ?.join("") || ""
}

export { capitalizeFirstLetter, splitString, isNumericOrEmpty, getFirstLetters };